import PropTypes from "prop-types";
import Modal from "../modal/Modal";
import { MODAL_TYPE } from "../../constants";
import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import getTermsAndPrivacyContent from "./getTermsAndPrivacyContent";
import { getAsosWorldUrl } from "./getAsosWorldUrl";
import styles from "./LoyaltySuccessModal.scss";

const LoyaltySuccessModal = ({ open, closeModal }) => {
  const { getTranslation, webContext, siteDomain } = useRuntimeConstants();
  const customerCopy = getTranslation("loyalty_terms_privacy_customer_copy");
  const termsAndPrivacyContent = getTermsAndPrivacyContent({
    loyalty_terms_privacy_hyperlink_copy: getTranslation(
      "loyalty_terms_privacy_hyperlink_copy",
    ),
    loyalty_terms_privacy_customer_copy: customerCopy,
  });
  const asosWorldBaseUrl = `${
    siteDomain?.endsWith("/") ? siteDomain : `${siteDomain || ""}/`
  }${getAsosWorldUrl(webContext.storeId)}`;

  return (
    <Modal
      open={open}
      closeModal={closeModal}
      modalType={MODAL_TYPE.CENTER}
      contentLoaded
      modalId="LoyaltySuccessModal"
    >
      <div className={styles.loyaltyOptInModal}>
        <div className={styles.icon}>
          <div className="product-asos-world" />
        </div>
        {getTranslation("ea_new_in_joined_modal_title")
          .split("\n")
          .map((line) => (
            <div className={styles.header} key={line.trim()}>
              {line.trim()}
            </div>
          ))}
        <div className={styles.copy}>
          {getTranslation("quick_join_overlay_body_web")}
        </div>
        <Button
          type={BUTTON_TYPES.loyaltyFullWidth}
          handleClick={closeModal}
          additionalClasses={styles.startShoppingButton}
        >
          {getTranslation("ea_new_in_joined_modal_cta")}
        </Button>
        <div className={styles.termsLinkText} aria-label={customerCopy}>
          {termsAndPrivacyContent.beforeTerms}
          <a
            href={`${asosWorldBaseUrl}terms-and-conditions`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {termsAndPrivacyContent.termsLinkText}
          </a>
          {termsAndPrivacyContent.between}
          <a
            href={`${asosWorldBaseUrl}privacy-policy`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {termsAndPrivacyContent.privacyLinkText}
          </a>
          {termsAndPrivacyContent.afterPrivacy}
        </div>
      </div>
    </Modal>
  );
};

LoyaltySuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default LoyaltySuccessModal;
